import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import CompanySection from '@/components/steps/InvoicingStep/CompanySection';
import ContactSection from '@/components/steps/InvoicingStep/ContactSection';
import InvoicingSection from '@/components/steps/InvoicingStep/InvoicingSection';
import { InvoiceDataSchema, type InvoiceDataSchemaType } from '@/components/steps/InvoicingStep/invoiceDataSchema';
import { useScrollToTopWhenLoaded } from '@/hooks/useScrollToTopWhenLoaded';
import { useUserStore } from '@/stores/userStore';

import StepBody from '../StepBody';

type InvoicingDataStepProps = {
    state: InvoiceDataSchemaType;
    setState: (state: InvoiceDataSchemaType) => void;
    handleNext: () => void;
    handleBack: () => void;
};

const InvoicingDataStep = (props: InvoicingDataStepProps) => {
    useScrollToTopWhenLoaded();
    const { state, setState, handleNext, handleBack } = props;
    const { account } = useUserStore();

    const {
        control,
        register,
        handleSubmit,
        setValue,
        watch,
        trigger,
        formState: { errors },
    } = useForm<InvoiceDataSchemaType>({
        defaultValues: {
            ...state,
            contact: {
                ...state.contact,
                languageOfCommunication: account?.language,
            },
        },
        shouldFocusError: false,
        resolver: zodResolver(InvoiceDataSchema()),
    });

    const onSubmit = (data: InvoiceDataSchemaType) => {
        setState(data);
        handleNext();
    };

    return (
        <StepBody stepId='invoicingData' handleNext={handleSubmit(onSubmit)} handleBack={handleBack}>
            <CompanySection
                register={register}
                control={control}
                watch={watch}
                errors={errors}
                setValue={setValue}
                state={state}
            />
            <ContactSection register={register} control={control} errors={errors} />
            <InvoicingSection
                register={register}
                control={control}
                watch={watch}
                setValue={setValue}
                trigger={trigger}
                errors={errors}
            />
        </StepBody>
    );
};

export default InvoicingDataStep;
